export const windowIsDefined = typeof window === 'object';

export const isIE = windowIsDefined && (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent)|| /Trident/i.test(navigator.userAgent) );

export const isEdge = windowIsDefined && window.navigator.userAgent.indexOf("Edge") > -1;

export const isSafari = windowIsDefined && navigator.userAgent.includes('Safari') && !navigator.userAgent.includes('Chrome');
